import trim from 'lodash/trim';
import { SITE_ROOT } from './constants';

export const buildRootUrl = (pathname = '') => {
    const root = `${SITE_ROOT}`;
    const path = trim(pathname, '/');
    return `${root}${path}${path.length > 0 ? '/' : ''}`;
};

export const attractionsUrl = ({ destination, category, from, to }) => {
    const qs = from && to ? `?from=${from}&to=${to}` : '';
    if (destination && category) {
        return `/attractions/${destination}/${category}/${qs}`;
    }
    if (destination) {
        return `/attractions/${destination}/${qs}`;
    }
    return '/';
};

export const destinationUrl = ({ state, slug }) => {
    if (state && slug) {
        return `/destination/${state}/${slug}/`;
    }
    return '/';
};

export const destinationStoriesUrl = ({ state, slug }) => {
    if (state && slug) {
        return `/traveler-stories/${state}/${slug}/`;
    }
    return '/';
};

export const destinationPartnersUrl = ({ slug }) => {
    if (slug) {
        return `/partners/${slug}/`;
    }
    return '/';
};

export const destinationBlogsUrl = ({ state, slug }) => {
    if (state && slug) {
        return `/blog/${state}/${slug}/`;
    }
    return '/';
};

export const contentPageUrl = ({ slug }) => {
    if (slug) {
        return `/${slug}/`;
    }
    return '/';
};

export const blogPostPageUrl = ({ slug }) => {
    if (slug) {
        return `/blog/${slug}/`;
    }
    return '/';
};

export const storyPageUrl = ({ slug }) => {
    if (slug) {
        return `/traveler-stories/${slug}/`;
    }
    return '/';
};
